import { useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";
import useFetch from "../../hooks/use-fetch";
import { useContext } from "react";
import { UserContext } from "../../context-provider/UserProvider";
import CompanySelect from "../company-select";
import CustomersTable from "./customer-table";
import IconButton from "../ui/button";
import { useHistory } from "react-router-dom";
import Paginate from "../ui/pagination";
import TableProvider from "../../context-provider/TableProvider";

const CustomersView = () => {
  const { companyId, setCompanyId } = useContext(UserContext);
  const history = useHistory();

  const api = useFetch({
    customers: [
      {
        guid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
    ],
  });

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "1em 0em",
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          <h2 style={{ marginRight: "15px" }}>Customers</h2>
          <CompanySelect setCompanyId={setCompanyId} />
        </div>

        <div>
          <IconButton
            title="Add"
            text="New Customer"
            onClick={() => {
              history.push("/customers/add");
            }}
            icon="add"
          />
        </div>
      </div>
      <TableProvider>
        <CustomersTable api={api} companyId={companyId} />
      </TableProvider>
    </div>
  );
};

export default CustomersView;
